import { createRoute } from 'framework/routing';

const PAYROLL_WORKING_HOURS_PATH = '/payroll/working-hours';

export const getWorkingHoursListUrl = () => PAYROLL_WORKING_HOURS_PATH;

export const getWorkingHoursRouterPath = () => PAYROLL_WORKING_HOURS_PATH;

export const useWorkingHoursRoute = () => createRoute({ listRoute: PAYROLL_WORKING_HOURS_PATH });
